import type { DashTrialNotificationsLastSeen } from "@mirage/service-dash-trial/service";
import { ONE_DAY_IN_SECONDS } from "@mirage/shared/util/constants";
import type { LargeKvStore } from "@mirage/storage/large-kv-store/interface";
import { getTodaysDateString } from "./utils";

type DashTrialNotificationsLastSeenContents = {
  lastSeen: DashTrialNotificationsLastSeen;
  dateLastUpdated: string;
};

const CACHED_DASH_TRIAL_NOTIFICATIONS_LAST_SEEN_KEY =
  "DashTrialNotificationsLastSeen";

// Refresh the cache every 12 hours
const CACHE_EXPIRATION_TIME_IN_SECONDS = ONE_DAY_IN_SECONDS / 2;

export class DashTrialNotificationsLastSeenCache {
  public constructor(private readonly store: LargeKvStore) {}

  public async getDashTrialNotificationsLastSeen(): Promise<
    DashTrialNotificationsLastSeenContents | undefined
  > {
    const cachedDashTrialNotificationsLastSeen = await this.store.get(
      CACHED_DASH_TRIAL_NOTIFICATIONS_LAST_SEEN_KEY,
    );
    if (cachedDashTrialNotificationsLastSeen) {
      return JSON.parse(cachedDashTrialNotificationsLastSeen);
    }
    return undefined;
  }

  public async setDashTrialNotificationsLastSeen(
    dashTrialNotificationsLastSeen: DashTrialNotificationsLastSeen,
  ): Promise<void> {
    await this.store.set(
      CACHED_DASH_TRIAL_NOTIFICATIONS_LAST_SEEN_KEY,
      JSON.stringify({
        lastSeen: dashTrialNotificationsLastSeen,
        dateLastUpdated: getTodaysDateString(),
      }),
      CACHE_EXPIRATION_TIME_IN_SECONDS,
    );
  }
}
